import { type FC, useRef } from "react";
import { useSelector } from "react-redux";
import { AnimatedTooltip } from "widgets";
import { useTooltip } from "widgets/hooks";

import type { User } from "@/graphql.ts";
import { getUserDisplayName, getUserTooltipDisplayName } from "@/modules/users/utils/user.ts";
import type { IAppState } from "@/redux/reducer.ts";

export const RelativeUserLabel: FC<{ user: Pick<User, "username" | "firstName" | "lastName"> }> = (props) => {
  const triggerRef = useRef<HTMLSpanElement>(null);
  const { triggerProps, tooltipProps, state } = useTooltip(triggerRef, { closeDelay: 0 });

  // TODO load current User internally (not from redux)
  const currentUser = useSelector<IAppState, User>((state) => state.auth.session);
  const username = currentUser?.username;

  const isItemCreator =
    !!username && !!props.user?.username && props.user.username.toLowerCase() === username.toLowerCase();

  return (
    <>
      <span {...triggerProps} data-testid="user" ref={triggerRef}>
        {isItemCreator ? "you" : getUserDisplayName(props.user)}
      </span>
      <AnimatedTooltip targetRef={triggerRef} state={state} domProps={tooltipProps} nonInteractive>
        {getUserTooltipDisplayName(props.user)}
      </AnimatedTooltip>
    </>
  );
};
